import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';
import { MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';
import ResponsiveDimensionValues from '../../../components/common/responsive-dimension-values';

const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;
const WINDOW_HEIGHT = ResponsiveDimensionValues.windowHeight;

export default MediaQueryStyleSheet.create(
  { 
    logo: {
      height: 30,
      width: 30,
      paddingLeft: 30,
    },
    logoDisable: {
      height: 30,
      width: 30,
      paddingLeft: 30,
      opacity: 0.3,
    },
    displayPdf: {
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      alignSelf: 'center',
    },
    pdfContainer: {
      flex: 1,
    },
    
    mrgnTp: {
      marginTop: 20,
    },
    list: {
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: PALETTE.primaryStrokeLine,
    },
    listItem: {
      backgroundColor: PALETTE.etbWithinGrace,
    },
    centerMiddle: {
      position: 'absolute',
      top: WINDOW_HEIGHT / 2 - 8,
      left: WINDOW_WIDTH / 2 - 8,
      zIndex: 4,
    },
    root: {
    },
  },
  {
    [MQ_TABLET]: {
      root: {
        marginTop:15,
      },
    },
  }
);
